import React from "react";

const TermsClause = ({ number, paragraphs }) => {
  return (
    <div className="flex-row-only text-top gap-20">
      <div className="text-small">{number}</div>
      <div className="flex-column gap-10">
        {paragraphs.map((paragraph) => (
          <div className="text-small" key={paragraph}>
            {paragraph}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TermsClause;
